import * as React from 'react'
import * as ReactDOM from 'react-dom'
import {
  UseConfirmationModalProps,
  ConfirmationModal
} from '../components/shared/Modal'

export const useConfirmation = (): UseConfirmationResult => {
  const [isConfirmationOpen, setConfirmationOpen] = React.useState(false)
  const [confirmationCallback, setConfirmationCallback] = React.useState<
    ((confirmed: boolean) => void) | null
  >(null)

  const openConfirmation = (callback: (confirmed: boolean) => void) => {
    setConfirmationCallback(() => {
      return (confirmed: boolean) => {
        callback(confirmed)
        setConfirmationOpen(false)
      }
    })

    setConfirmationOpen(true)
  }

  const closeConfirmation = () => {
    if (confirmationCallback) {
      confirmationCallback(false)
    }

    setConfirmationOpen(false)
  }

  const ConfirmationModalComponent: React.FC<UseConfirmationModalProps> =
    React.useMemo(
      () =>
        ({ onClose, ...rest }) => {
          const modalRoot = document.getElementById('modal-root')

          if (!modalRoot) return null

          const portalContent = (
            <ConfirmationModal
              {...rest}
              onCancel={() => onClose(false)}
              onConfirm={() => onClose(true)}
            />
          )

          return ReactDOM.createPortal(
            portalContent,
            modalRoot
          ) as React.ReactPortal
        },
      []
    )

  return {
    isConfirmationOpen,
    openConfirmation,
    closeConfirmation,
    ConfirmationModalComponent
  }
}

export interface UseConfirmationResult {
  isConfirmationOpen: boolean
  openConfirmation: (callback: () => void) => void
  closeConfirmation: () => void
  ConfirmationModalComponent: React.FC<UseConfirmationModalProps>
}
